"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Truncates a string to the given maximum
 * length if it exceeds that length. Attaches
 * an opptional suffix to the string if provided.
 *
 * @param originalText The text to truncate.
 * @param maxLength    The maximum desired length of the string.
 * @param suffix       Suffix added to the end of the string if truncated.
 *
 * @returns The truncated string.
 */
function truncateText(originalText, maxLength, suffix) {
    if (suffix === void 0) { suffix = ''; }
    var text = originalText;
    // If the text is shorter than max length
    // return original text
    if (text.length <= maxLength) {
        return text;
    }
    // Cut the text to length
    text = text.substring(0, maxLength);
    // Add the suffix
    text = "" + text + suffix;
    return text;
}
exports.default = truncateText;
//# sourceMappingURL=truncateText.js.map